import { Toaster } from '@/components/ui/toaster';
import Header from '@/components/Layout/Header';
import Footer from '@/components/Layout/Footer';
import Hero from '@/components/Sections/Hero';
import About from '@/components/Sections/About';
import Services from '@/components/Sections/Services';
import Team from '@/components/Sections/Team';
import Appointment from '@/components/Sections/Appointment';
import News from '@/components/Sections/News';
import Reviews from '@/components/Sections/Reviews';
import Contact from '@/components/Sections/Contact';

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main>
        <Hero />
        <About />
        <Services />
        <Team />
        <Appointment />
        <Reviews />
        <News />
        <Contact />
      </main>
      <Footer />
      <Toaster />
    </div>
  );
};

export default Index;
